export default __webpack_public_path__ + "48dad7b37c7a741447e77fd038b11aa8.svg";